import React, { Component, PropTypes } from 'react';
import {reduxForm} from "redux-form";
import {GetInterfaceLang, GetOneLanguage, GetOneLearningLanguage, saveRule, getDetailRule, saveRuleEdit, DelRule} from '../../actions/index';
import {Link} from 'react-router';

class AddRule  extends Component {
    static contextTypes = {
        router: PropTypes.object
    };
    constructor(props){
        super(props);
        this.state={
            word: ''
        }
        this.renderTranslate = this.renderTranslate.bind(this);
        this.onChange = this.onChange.bind(this);
        this._logStateRaw = this._logStateRaw.bind(this);
        this.SubmitForm = this.SubmitForm.bind(this);
        this.changeInput = this.changeInput.bind(this);
        this.nameRule = this.nameRule.bind(this);
        this.delRule = this.delRule.bind(this);
        this.delRuleOpenModal = this.delRuleOpenModal.bind(this);
    }
    componentWillMount(){
        let token = localStorage.getItem('id_token_admin');
        this.props.GetInterfaceLang(token);
        this.props.GetOneLearningLanguage(this.props.params.id, token);
        if(this.props.params.id_rule){
            this.props.getDetailRule(this.props.params.id_rule, token, this.props.params.id);
        }
    }
    componentDidMount(){
        $('#word').keypress(function () {
            $(this).parent().removeClass('has-error')
        });
    }
    componentWillUnmount(){
        this.props.lang.rule_detail = {}
    }
    edit(e){
        let block = $(e.target).data('id')
        $('#'+block+' .idetBlock').summernote({
                lang: "ru-RU",
                height: 150,
                dialogsInBody: true,
                toolbar: [
                    ["font", ["bold", "underline", "clear"]],
                    ['fontsize', ['fontsize']],
                    ['color', ['color']],
                    ["para", ["ul", "ol", "paragraph"]],
                    ["table", ["table"]],
                    ["insert", ["link", "picture", "video"]],
                    ["view", ["fullscreen", "codeview"]]
                ]
            });
        $('#'+block+' .btn-primary').show();
    };
    save(e){
        let block = $(e.target).data('id')
        let makrup = $('#'+block+' .idetBlock').summernote('code');
        $('#'+block+' .idetBlock').summernote('destroy');
        $('#'+block+' .btn-primary').hide();
        $('#'+block+' .idetBlock').parent().removeClass('has-error');
    };
    SubmitForm(){
        let token = localStorage.getItem('id_token_admin');
        let block = $('.addWordBlock');
        let arr = [];
        if($('#rule').val() != ''){
            for(let i=0; i<block.length; i++){
                let oneBlock = block[i];
                if($(oneBlock).find('input').val() != ''){
                    if($(oneBlock).find('.idetBlock').html() != '' && $(oneBlock).find('.idetBlock').html() != '<p><br></p>'){
                        let obj={
                            content: $(oneBlock).find('.idetBlock').html(),
                            name: $(oneBlock).find('input').val(),
                            blang: parseInt($(oneBlock).attr('id'))
                        }
                        arr.push(obj)
                    }else{
                        $(oneBlock).find('.idetBlock').parent().addClass('has-error');
                    }
                }else{
                    $(oneBlock).find('input').parent().addClass('has-error');
                }
            }
            if($('.form_rule').find('.has-error').length > 0){
                return false
            }else{
                let data= {
                    name: $('#rule').val(),
                    flang: parseInt(this.props.params.id),
                    translations: arr
                }
                if(this.props.params.id_rule){
                    this.props.saveRuleEdit(token, data, this.props.params.id_rule).then((response)=>{
                        if(response.payload.status == 200){
                            this.context.router.push('/language/learning/edit/'+this.props.params.id+'/grammar_page/');
                        }
                    });
                }else{
                    this.props.saveRule(token, data).then((response)=>{
                        if(response.payload.status == 201){
                            this.context.router.push('/language/learning/edit/'+this.props.params.id+'/grammar_page/');
                        }
                    });
                }
            }
        }else{
            $('#rule').parent().addClass('has-error');
        }
    }
    changeInput(e){
        this.setState({
            [e.target.name]: e.target.value
        });
        $(e.target).parent().removeClass('has-error');
    }
    delRule(){
        let token = localStorage.getItem('id_token_admin');
        this.props.DelRule(token, this.props.params.id_rule).then((response)=>{
            if(response.payload.status == 204){
                $('#DelWord').modal('hide');
                this.context.router.push('/language/learning/edit/'+this.props.params.id+'/grammar_page/');
                this.props.getGrammarPage(token, this.props.params.id);
            }
        });
    }
    delRuleOpenModal(){
        let token = localStorage.getItem('id_token_admin');
        let that= this;
        $('#DelWord').modal('show');
    }
    closeModal(){
        $('#DelWord').modal('hide');
    }
    _logStateRaw() {
        let editorState = this.state.value.getEditorState();
        let contentState = editorState.getCurrentContent();
        let rawContentState = window.rawContentState = convertToRaw(contentState);
    }
    translation(id) {
        if(id && this.props.lang.rule_detail.translations){
            return this.props.lang.rule_detail.translations.map((item)=>{
                if(item.blang == id){
                    return <div key={item.id} className="idetBlock" dangerouslySetInnerHTML={{__html: item.content}}></div>
                }
            });
        }else{
            return  <div className="idetBlock"></div>
        }
    }
    nameRule(item) {
        if(item.id && this.props.lang.rule_detail.translations){
            return this.props.lang.rule_detail.translations.map((block, i)=>{
                if(block.blang == item.id){
                    return (
                        <input key={i} type="text"
                               id={block.id}
                               defaultValue={block.name}
                               className="form-control"
                               onChange={this.changeInput}
                        />
                    )
                }
            });
        }else{
            return  (
                <input type="text"
                       id={item.id+'_'+item.lang.id}
                       className="form-control"
                       value={this.state[item.id+'_'+item.lang.id]}
                       onChange={this.changeInput}
                />
            )
        }
    }
    renderTranslate(){
        let elem = this.props.lang.interface_lang.results;
        return elem.map((item)=>{
            if(item.lang.id == this.props.lang.learning_lang_one.lang.id){
                return false
            }else{
                return(
                    <div className="row addWordBlock" id={item.id} key={item.lang.id}>
                        <p className="nameRule">{item.lang.name}</p>
                        <div className="row mb10">
                            <div className="col-md-4">
                                <label htmlFor={item.id+'_'+item.lang.id}>Rule name</label>
                            </div>
                            <div className='col-md-4'>
                                {this.nameRule(item)}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4">
                                <label>Description</label>
                            </div>
                            <div className="col-md-4" data-name={item.lang.name}>
                                {this.translation(item.id)}
                                <div className="blockBtn">
                                    <button id="edit" data-id={item.id} className="btn btn-default" onClick={this.edit} type="button">Edit</button>
                                    <button id="save" data-id={item.id} className="btn btn-primary" onClick={this.save} type="button">Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        })
    }
    onChange(e, content) {
        let nameBlock = $(e).parent().data('name');
        this.setState({
            [nameBlock]: content
        })
    }
    render() {
        const { fields: {
            name}, handleSubmit} = this.props;
        return (
            <div className="dashboard-wrapper">
                <p className="dashboard-title">{this.props.params.id_rule ? "Edit rule" : "Add rule"}</p>
                <p className="dashboard-text">Grammar page</p>
                <form className="form_rule">
                    <div className="col-md-12">
                        <div className="white-block block-4-8 clearfix">
                            <div className="clearfix blockTranslateRule">
                                <div className="row name_rule_block">
                                    <div className="col-md-4">
                                        <label htmlFor="rule">Rule name</label>
                                    </div>
                                    <div className="col-md-4">
                                        <input type="text"
                                               id="rule"
                                               placeholder="Rule name"
                                            {...name}
                                               className="form-control"
                                               name="rule"
                                        />
                                    </div>
                                </div>
                                {this.props.lang.interface_lang.results && this.props.lang.learning_lang_one.lang ?
                                    <div className="col-md-12">
                                        {this.renderTranslate()}
                                    </div>
                                    : ""
                                }
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="white-block clearfix">
                            <div className="col-md-12 text-center button-group">
                                <Link to={"/language/learning/edit/"+this.props.params.id+"/grammar_page/"} className="btn btn-default">Cancel</Link>
                                {this.props.params.id_rule ?
                                    <button type="button" onClick={this.delRuleOpenModal} className="btn btn-danger">Delete</button>
                                    :""}
                                <button type="button" onClick={this.SubmitForm} className="btn btn-primary">Save</button>
                            </div>
                        </div>
                    </div>
                </form>
                <div className="modal fade" id="DelWord" tabIndex="-1" role="dialog" aria-labelledby="DelWordLabel">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="close" onClick={this.closeModal} aria-label="Close"><span aria-hidden="true">&times;</span></button>
                            </div>
                            <div className="modal-body text-center">
                                <span className="glyphicon glyphicon-alert" aria-hidden="true" data-toggle="modal" data-target="#DelWord"></span>
                                <p>Do you really want to delete this rule {this.props.lang.rule_detail ? <span>{this.props.lang.rule_detail.name}</span> : ""}?</p>
                            </div>
                            <div className="modal-footer text-center">
                                <button onClick={this.closeModal} type="button" className="btn btn-default">No</button>
                                <button onClick={this.delRule} type="button" className="btn btn-primary">Yes</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="clearfix"></div>
            </div>
        );
    }
}

function validate(values) {
    const errors = {};
    if(!values.name){
        errors.name = 'Enter a title'
    }
    return errors;
}

function  mapStateToProps(state) {
    return{
        lang: state.lang,
        initialValues: {
            name: state.lang.rule_detail.name || ''
        }
    }
}
export default reduxForm({
    form: 'Add Rule',
    fields: ['name'],
    validate
}, mapStateToProps, {GetInterfaceLang, GetOneLanguage, GetOneLearningLanguage, saveRule, getDetailRule, saveRuleEdit, DelRule})(AddRule);



// WEBPACK FOOTER //
// ./src/components/language/addRule.js